import http from './httpService';
import config from './../config.json';

const address = config.api_address + config.api_order;

export const getAllOrders = (params, {signal}) => {
    return http.get(`${address}`, {params, signal});
}

export const getUserOrders = (params, {signal}) => {
    return http.get(`${address}/user-orders`, {params, signal});
}

export const getOrderItems = (orderId) => {
    return http.get(`${address}/getOrderItems/${orderId}`);
}

export const createOrder = (order) => {
    return http.post(`${address}`, order);
}
export const updateOrder = (oid, info) => {
    return http.patch(`${address}/edit-order/${oid}`, info);
}

export const updateOrderStatus = (oid, {newStatus}) => {
    return http.patch(`${address}/change-status/${oid}`, {newStatus});
}

export const sendConrimOrderMessage = (oid) => {
    return http.get(`${address}/confirm-sms/${oid}`);
}

export const getCombinePossibility = (orderId) => {
    return http.get(`${address}/combinePossibility/${orderId}`);
}

export const combineOrdersOfUser = (params) => {
    return http.get(`${address}/combine`, {params});
}

// export const updateOrderStatusGroup = ({newStatus}) => {
//     return http.patch(`${address}/statusGroup`, {newStatus});
// }

// export const updateOrderPaymentStatus = (oid, {newStatus, printData}) => {
//     return http.patch(`${address}/pay-mode/${oid}`, {newStatus, printData});
// }
// export const checkPaymentOrderStatus = (oid, sentStatus) => {
//     return http.get(`${address}/pay-mode/${oid}/${sentStatus}`);
// }

export const temporaryDeleteOrder = (oid) => {
    return http.delete(`${address}/blocked/${oid}`);
}

// export const blockDevice = (oid) => {
//     return http.get(`${address}/blacklist/${oid}`);
// }

// export const getBrandInfo = (oid) => {
//     return http.get(`${address}/deviceInfo/${oid}`);
// }

// export const getBrandInfo2 = (itemId) => {
//     return http.get(`${address}/blacklist/getInfo/${itemId}`);
// }

// export const getBlackList = (params, {signal}) => {
//     return http.get(`${address}/blacklist`, {params, signal});
// }

// export const deleteBlockedDevice = (bid) => {
//     return http.delete(`${address}/blacklist/${bid}`);
    
// }

// export const deleteOrderByUser = (oid) => {
//     return http.delete(`${address}/${oid}`);
    
// }